import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-topbar',
  standalone: false,
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss'
})
export class TopbarComponent {
  @Output() menuToggle = new EventEmitter<void>();
  @Input() isSidebarOpened = false;

  constructor(private readonly router: Router) {}

  onMenuToggle() {
    this.menuToggle.emit();
  }

  onNavigateToProfile(): void {
    this.router.navigate(['dashboard/users/profile']);
  }
}
